import { ReactElement } from 'react';
import { Typography } from '@mui/material';

import { useStyles } from './useStyles';

interface IInfoProps {
  label: string;
  value: string;
  subValue?: string;
}

export function Info({ value, subValue, label }: IInfoProps): ReactElement {
  const { classes } = useStyles();

  return (
    <div className={classes.root}>
      <Typography sx={{ opacity: 0.6 }} variant="body1">
        {label}
      </Typography>

      <Typography mt={3} variant="h3">
        {value}
      </Typography>

      {subValue && (
        <Typography
          sx={{ opacity: 0.6, mt: 1, fontWeight: 500 }}
          variant="body1"
        >
          {subValue}
        </Typography>
      )}
    </div>
  );
}
